import * as Types from './document.types';

export const saveDocumentForm = form => dispatch =>
  dispatch(Types.SAVE_DOCUMENT_FORM.SUCCESS.action(form));

export const cleanDocumentForm = () => dispatch =>
  dispatch(Types.CLEAN_DOCUMENT_FORM.SUCCESS.action());
